/**
 * @summary     app.hashRouter.js
 * @description App JS URL Hash Controller
 * @version     1.7
 	> 1.0 Initial version
		- 06/21/2016 SG
	> 1.1 Added selector support to be a string and compiled on run time
		- 10/11/2016
	> 1.2 Added support to exit out of compilers before they begin, added getPath()
		- 10/14/2016
	> 1.3 Passed compiler to onload functions
		- 01/22/2017
	> 1.4 Added paused feature to allow changes on the hash to be made without it firing the listener...this is for sorting or other features that are help on the URL without reloading the whole view
		- 06/07/2017
	> 1.5 Added individual onload listeners at the route level.  Added history and API.goBack() to traverse it
		- 06/16/2017
	> 1.6 Added ability to bypass router HTML compiler in case it's a custom route we want our own compiler own
		- 08/09/2017
	> 1.7 Added new argument to getUrlArgs for parsing URL JSON string arguments into object equivalents
		- 09/12/2017
 * @author      Silas Garrison (http://silasgarrison.com/)
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
*/

app.addFeature(
	"hashRouter",
	function(){
		"use strict";

		var self = this,
			identifier = "#!",
			routes = {
				"default" : null,
				"404" : null
			},
			missingRoutePath = "404",
			defaultRoutePath = "default",
			globalOnloadListeners = [],
			globalOnbeforeloadListeners = [],
			activePath = (document.location.hash.replace(identifier,"") || defaultRoutePath).split("?")[0],
			previousRoute = {},
			urlArgs = {},
			routeHistory = [],
			paused = false;

		/*
			Name: listener
			Use: PRIVATE.listener()
			Args: event HashChangeEvent - The event object
			Description: The global listener for hash change listeners
		*/
		function listener(event){
			var hash = document.location.hash,
				routePath = (hash.replace(identifier,"") || defaultRoutePath).split("?")[0],
				route = self.get(routePath),
				routeDefault = self.get(defaultRoutePath),
				routeMissing = self.get(missingRoutePath);

			urlArgs = {};

			/*
				NOTE:
					Pause can never last for very long
			*/
			if(paused){
				return;
			}

			/*
				NOTE:
					Pull in URL args
			*/
			((hash.replace(identifier,"") || defaultRoutePath).split("?")[1] || "").split("&").forEach(
				function(val){
					urlArgs[val.split("=")[0]] = decodeURIComponent(val.split("=")[1] || "");
				}
			);

			if(route !== null){
				self.load(routes[routePath],urlArgs);
			}
			else {
				if(routeMissing === null){
					console.log("404! No router or handler found for: " + routePath);
				}
				else {
					self.load(routeMissing,urlArgs);
				}
			}
		}

		/*
			Name: init
			Use: API.init()
			Args: none
			Description:
		*/
		self.init = function(){
			window.addEventListener("hashchange",listener);

			app.onInit(listener);

			return self;
		};

		/*
			Name: set
			Use: API.set()
			Args: route ObjectRouter - The hashmap that defines the route
			Description: Defines a route
		*/
		self.set = function(route){
			routes[route.path] = route;

			return self;
		};

		/*
			Name: pause
			Use: API.pause()
			Args: none
			Description: Pauses the hash change listener for 750ms
		*/
		self.pause = function(){
			paused = true;
			(
				function(){
					paused = false;
				}
			).After(750);
		};

		/*
			Name: get
			Use: API.get()
			Args: routePath String - The path of the route
			Description: Retrieves a route
		*/
		self.get = function(routePath){
			return routes[routePath] || null;
		};

		/*
			Name: goBack
			Use: API.goBack()
			Args: none
			Description: Goes back to the previous route
		*/
		self.goBack = function(){
			if(routeHistory[routeHistory.length - 2] && routes[routeHistory[routeHistory.length - 2].path]){
				document.location.hash = identifier + routeHistory[routeHistory.length - 2].path + "?" + JSON.toURL(routeHistory[routeHistory.length - 2].urlParams);
			}
			else {
				document.location.hash = identifier + defaultRoutePath + "?noHistory";
			}
			/*
				NOTE:
					Since we're going back, bump it off history
			*/
			routeHistory.splice(Math.max(routeHistory.length - 2,0));
		};

		/*
			Name: load
			Use: API.load()
			Args: route ObjectRouter - The hashmap that defines the route
					urlParams Object - Properties from the url
			Description: Executes a route
		*/
		self.load = function(route,urlParams){
			var def = app.deferred(),
				doStart = true;

			if(previousRoute.path && routes[previousRoute.path] && routes[previousRoute.path].onbeforeunload){
				/*
					NOTE:
						If it returns false, don't actually load next route
				*/
				if(routes[previousRoute.path].onbeforeunload(route,urlParams) === false){
					return;
				}
			}

			activePath = route.path;

			/*
				NOTE:
					bounce() is a method used to redirect if specified on the url
			*/
			if(route.bounce === undefined){
				route.bounce = function(path,args,fallback){
					var redir = urlParams.redir;

					if(redir !== undefined && (fallback === undefined || fallback === true)){
						path = redir;
					}
					path = identifier.append(path).append("?").append(args || "").append(args?"&":"").append("rand=").append(Math.random());
					/*
						NOTE:
							Kill off deferred because obviously we want to stop processing on this page if we're bouncing
					*/
					def.kill();

					/*
						NOTE:
							Don't bounce immediately to allow any modals or such to process properly
					*/
					(
						function(){
							document.location.hash = path;
						}
					).After(50);
				};
			}

			globalOnbeforeloadListeners.forEach(
				function(fn){
					try {
						/*
							NOTE:
								If the before listeners return false, that's strictly saying don't finish loading
						*/
						if(fn(route,urlParams) === false){
							doStart = false;
						}
					}
					catch(e){}
				}
			);

			if(doStart && typeof route.onbeforeload === "function"){
				doStart = route.onbeforeload(route,urlParams);
			}

			if(typeof route.router === "function"){
				/*
					NOTE:
						A router can just be a custom function that does anything
				*/
				route.router(route);
			}
			/*
				NOTE:
					The default approach is a basic HTML template with a compiler or precompiler (aka Ajax call)
			*/
			else {
				route.template = typeof route.template === "string"?route.template:route.path;

				/*
					Step: IF there's a precompiler it MUST return a deferred object with the def.results() set to the object meant for compiling
				*/
				def.step(
					function(){
						if(typeof route.precompiler === "function"){
							route.precompiler(
								route,
								urlParams
							).finished(def.next);
						}
						else if(typeof route.compiler === "function"){
							def.next(
								route.compiler(
									route,
									urlParams
								)
							);
						}
						else {
							def.next(route.compiler);
						}
					}
				);

				/*
					Step: Grab the template, compile it then try to render it with native DOM object then with a jQuery object
				*/
				def.step(
					function(compiler){
						/*
							NOTE:
								Don't compile the page if the compiler is a boolean flag of false - gives us a way of exiting out
						*/
						if(compiler === false){
							return;
						}

						var comp = compiler || {};

						comp.urlParams = urlParams;
						comp.route = route;
						if(app.dataStore){
							comp.dataStore = app.dataStore.get();
						}

						app.templates.get(route.template).finished(
							function(res){
								// Allow a flag to be passed in and bypass compilation
								var results = route.noCompile === true ? (comp.html || res) : (comp.html || res).compile(comp);

                 // Update the page title on hash change
                 const pageTitle = (route.pageTitle ?? route.path ?? '').toProperCase();
                 const jurisdiction = app.jurisdiction.get();
                 document.title = `${pageTitle ? `${pageTitle} | `: ''}${jurisdiction ? `${jurisdiction.titles.full} | My Health Department`: ''}`; 

								/*
									NOTE:
										CSS selectors as a string for the target
								*/
								if(typeof route.target === "string"){
									if(window.jQuery){
										$(route.target).html(results);
									}
									else {
										document.querySelectorAll(route.target).forEach(
											function(el){
												el.innerHTML = results;
											}
										);
									}
								}
								/*
									NOTE:
										HTML node as the target
								*/
								else if(route.target.innerHTML !== undefined){
									route.target.innerHTML = results;
								}
								/*
									NOTE:
										Target as a function for special processing
								*/
								else if(typeof route.target === "function"){
									route.target(
										results,
										route,
										urlParams,
										comp
									);
								}
								/*
									NOTE:
										jQuery object as the target
								*/
								else {
									route.target.html(results);
								}

								(
									function(){
										if(typeof route.onload === "function"){
											route.onload(route,urlParams,comp);
										}

										/*
											NOTE:
												Ensure we always start at the top of the page
										*/
										if(window.jQuery){
											$(window).scrollTop(0);
										}
										else {
											window.scrollTo(0,0);
										}

										globalOnloadListeners.forEach(
											function(fn){
												try {
													fn(route,urlParams,comp);
												}
												catch(e){}
											}
										);
									}
								).After(50);
							}
						);
					}
				);

				/*
					NOTE:
						Do 150ms because if there are DOM changes in pre load listeners then they sometimes don't fire
						Push route into history and ensure we fire any onunload listeners from the previous route
				*/
				if(doStart){
					previousRoute = {
						path : route.path,
						urlParams : urlParams
					};
					routeHistory.push(
						{
							path : route.path,
							urlParams : urlParams
						}
					);
					def.begin.After(150,[],def);
				}
			}

			return self;
		};

		/*
			Name: onload
			Use: API.onload()
			Args: fn Function - The function we want to fire
			Description: Adds a function to fire globally for all routes after they load
		*/
		self.onload = function(fn){
			if(typeof fn === "function"){
				globalOnloadListeners.push(fn);
			}

			return self;
		};

		/*
			Name: onbeforeload
			Use: API.onbeforeload()
			Args: fn Function - The function we want to fire
			Description: Adds a function to fire globally for all routes before they load
		*/
		self.onbeforeload = function(fn){
			if(typeof fn === "function"){
				globalOnbeforeloadListeners.push(fn);
			}

			return self;
		};

		/*
			Name: go
			Use: API.go()
			Args: path String - Hash route/path
					args Object|String - Hashmap of URL args
			Description: Redirects to the appropriate page
		*/
		self.go = function(path, args){
			var urlStr = typeof args === 'string'?args:(args !== undefined?JSON.toURL(args):'');

			document.location.hash = identifier + path + "?" + urlStr;
			return self;
		};

		/*
			Name: getPath
			Use: API.getPath()
			Args: none
			Description: Returns the active path
		*/
		self.getPath = function(){
			return activePath;
		};

		/*
			Name: getUrlArgs
			Use: API.getUrlArgs()
			Args: pullFresh Boolean - If true, it will grab the URL parameters off the current hash string instead of using the cached version as the current hash router is running off of. Default is false
					doParse Boolean - If true, it'll try to parse any JSON or object based properties. Default is true
			Description: Returns the URL args of the current route
		*/
		self.getUrlArgs = function(pullFresh, doParse){
			var lclUrlArgs = urlArgs,
				key;

			if(pullFresh??false){
				lclUrlArgs = {};

				/*
					NOTE:
						Pull in URL args
				*/
				((document.location.hash.replace(identifier,"") || defaultRoutePath).split("?")[1] || "").split("&").forEach(
					function(val){
						lclUrlArgs[val.split("=")[0]] = decodeURIComponent(val.split("=")[1] || "");
					}
				);
			}

			/*
				NOTE:
					Try to parse right kind of data
			*/
			if(doParse??true){
				lclUrlArgs = JSON.clone(urlArgs)
				for(key in lclUrlArgs){
					if(!isNaN(lclUrlArgs[key]) && lclUrlArgs[key] !== ""){
						lclUrlArgs[key] = (lclUrlArgs[key] || "").val();
					}
					else if((lclUrlArgs[key].indexOf("{") !== -1 && lclUrlArgs[key].indexOf("}") !== -1) || (lclUrlArgs[key].indexOf("[") !== -1 && lclUrlArgs[key].indexOf("]") !== -1)){
						try {
							lclUrlArgs[key] = JSON.parse(lclUrlArgs[key]);
						}
						catch(e){}
					}
				}
			}

			return lclUrlArgs;
		};

		return self;
	}
);
